/* eslint-disable no-console */
import React, { useEffect } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";

import MenuStart from "./MenuStart";
import ChallengeOpponent from "./ChallengeOpponent";
import Settings from "./Settings";
import AcceptOpponent from "./AcceptOpponent";
import CategoryMenu from "./CategoryMenu";
import Profile from "./Profile";
import GetReadyLoading from "./GetReadyLoading";
import Stats from "./Stats";
import NotificationsPanel from "./NotificationsPanel";
import routes from "../../utils/routes.json";
import MatchMaking from "./Matchmaking";
import TermsAndConditions from "./TermsAndConditions";
import Game from "./Game";
import Practice from "./Practice";
import Page404 from "./404";
import PracticeResult from "./PracticeResult";

import Echo from "laravel-echo";
import Pusher, { Channel } from "pusher-js";
import api from "../../utils/api";
import { UserContext } from "../../viewmodel/providers/user-context";
import { AuthorizerOptions } from "pusher-js/types/src/core/auth/options";
import Rematch from "./Rematch";
import TournamentCreator from "./TournamentCreator";
import TournamentInvited from "./TournamentInvited";
import FriendsList from "./FriendsList";
import MatchFriends from "./MatchFriends";
import DailyQuestion from "./DailyQuestion";
import DailyResult from "./DailyResult";


export default function AppRouter(): JSX.Element {

    const userId: string = React.useContext(UserContext).userId;
    const addNotification = React.useContext(UserContext).addNotification;
    const notifications = React.useContext(UserContext).notifications;

    useEffect(() => {
        const wsPort: number = parseInt(process.env.REACT_APP_WEBSOCKETS_WS_PORT || "6001")
        const wssPort: number = parseInt(process.env.REACT_APP_WEBSOCKETS_WSS_PORT || "443")
        const pusherConfig = {
            key: "12345",
            cluster: "mt1",
            wsHost: process.env.REACT_APP_WSHOST,
            wsPort: wsPort,
            wssPort: wssPort,
            broadcaster: "pusher",
            disableStats: true,
            encrypted: false,
            forceTLS: false,
            authorizer: (channel: Channel, options: AuthorizerOptions) => {
                console.log(options);
                return {
                    authorize: (socketId: string, callback: Function) => api.post("broadcasting/auth", {
                        "socket_id": socketId,
                        "channel_name": channel.name,
                    }).then((response) => {
                        callback(false, response);
                    }).catch((error) => {
                        callback(true, error);
                    }),
                };
            },
        };

        const echo = new Echo({
            broadcaster: "pusher",
            client: new Pusher("12345", pusherConfig),
        });

        const notificationChannel = `App.Models.User.${userId}`;

        const channel = echo.channel(notificationChannel);
        channel.listen(".UserMessages", (e: any) => {
            addNotification(e);
            return;
        });

        return () => {
            echo.leave(notificationChannel);
            console.log("leaving");
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    console.log(notifications);

    return (
        <Router>
            <Switch>
                <Route path={routes.terms}>
                    <TermsAndConditions />
                </Route>
                <Route path={routes.stats}>
                    <Stats />
                </Route>
                <Route path={routes.practiceResults}>
                    <PracticeResult />
                </Route>
                <Route path={routes.settings}>
                    <Settings />
                </Route>
                <Route path={routes.challenge}>
                    <ChallengeOpponent />
                </Route>
                <Route path={routes.acceptOpponent}>
                    <AcceptOpponent />
                </Route>
                <Route path={routes.matchmaking}>
                    <MatchMaking />
                </Route>
                <Route path={routes.practice_categories}>
                    <CategoryMenu mode={"practice"} />
                </Route>
                <Route path={routes.categories}>
                    <CategoryMenu mode={"play"} />
                </Route>
                <Route exact path={routes.daylyresult}>
                    <DailyResult />
                </Route>
                <Route path={routes.dailyquestion}>
                    <DailyQuestion />
                </Route>
                <Route path={routes.matchfriends_categories}>
                    <CategoryMenu mode={"matchfriends"} />
                </Route>
                <Route path={routes.replay}>
                    <Rematch />
                </Route>
                <Route path={routes.matchfriends}>
                    <MatchFriends />
                </Route>
                <Route path={routes.ready}>
                    <GetReadyLoading duration={3} />
                </Route>
                <Route path={routes.tournamentCreator}>
                    <TournamentCreator />
                </Route>
                <Route path={routes.tournamentInvited}>
                    <TournamentInvited />
                </Route>
                <Route path={routes.tournamentGames}>
                    <TournamentCreator />
                </Route>
                <Route path={routes.notificationsPanel}>
                    <NotificationsPanel />
                </Route>
                <Route path={routes.profile}>
                    <Profile />
                </Route>
                <Route path={routes.friendsList}>
                    <FriendsList />
                </Route>
                <Route exact path={routes.game}>
                    <Game />
                </Route>
                <Route path={routes.practice}>
                    <Practice />
                </Route>
                <Route exact path={routes.menu}>
                    <MenuStart />
                </Route>
                <Route
                    path={routes.editAccout} component={() => {
                        window.location.href = "https://www.zerozero.pt/alterar_user.php";
                        return null;
                    }}
                />
                <Route path="*">
                    <Page404 />
                </Route>
            </Switch>
        </Router>
    );
}
